require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-how-microinteractions-create-memorable-user-experiences.json") })
        }
      }, "path---blog-how-microinteractions-create-memorable-user-experiences");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-how-microinteractions-create-memorable-user-experiences!./.cache/json/blog-how-microinteractions-create-memorable-user-experiences.json
// module id = 452
// module chunks = 231608221292675